module.exports = __webpack_public_path__ + "img/l_st.5528e3dc.png";